import {
    getLocalizedMoreInfoTextServ,
    getLocalizedTextServ
} from '../_shared/GWTBridge/invoke/server';

const locatedTexts = {
    51: 'F11',
    74: 'Search',
    97: 'Advanced Search',
    148: 'Form Help',
    400: 'ok',
    404: 'Help',
    470: "חיפוש '<#P0>' נשמרה במיקום <#P1> מקש קיצור: <#P2>",
    472: "חיפוש '<#P0>' נשמרה במיקום <#P1>.",
    1247: 'custom range',
    1248: 'from',
    1249: 'to',
    1359: 'Save',
    1417: 'שווה ל-',
    1418: 'notEquals',
    1419: 'less',
    1420: 'greater',
    1421: 'less or equal',
    1422: 'greater or equal',
    1423: 'later',
    1424: 'before',
    1425: 'between',
    1426: 'starts with',
    1427: 'ends with',
    1428: 'contains',
    1453: 'clear search',
    1454: 'Apply',
    1455: 'Save As New',
    1456: 'Save And Apply',
    1457: 'clearFilter',
    1570: 'XXX Selected',
    1571: 'Select All',
    1580: 'Quick label print',
    1591: 'Print Label',
    1619: 'Quick Print is not availible'
};

let getGenMsgFromServer;

export function initTextConsts(funcs) {
    getGenMsgFromServer = funcs && funcs.getGenMessage;
}

export function getString(key) {
    return locatedTexts && locatedTexts[key];
}

export function getLocalizedText(key) {
    return getLocalizedTextServ(key);
}

export function getLocalizedMoreInfoText(key) {
    return getLocalizedMoreInfoTextServ(key);
}

export function getGeneratorMsg(key) {
    return getGenMsgFromServer && getGenMsgFromServer(key);
}

export const placeholders = {
    activeFieldPackTitle: 'XXX',
    entityName: 'XXX',
    dependentPacks: 'YYY',
    searchTitle: '<#P0>',
    searchPlace: '<#P1>',
    searchHotKey: '<#P2>'
};

export const texts = {
    selectCompany: 17,
    edit: 20,
    F11: 51,
    multiSelectTitle: 55,
    dirActs: 58,
    search: 1577,
    advancedSearch: 97,
    formHelp: 148,
    shareRecord: 172,
    definingRulesAndPatterns: 1446,
    default: 303,
    ok: 400,
    cancel: 401,
    help: 404,
    merge: 414,
    split: 415,
    newBox: 416,
    sameBox: 417,
    setCover: 419,
    setDefault: 469,
    savedWithHotKey: 470,
    moreAction: 471,
    savedWithoutHotKey: 472,
    restoreWarn: 550,
    doubleTab: 551,
    uploadFileTooltipText: 659,
    formReenter: 660,
    newEntry: 731,
    packagesName: 735,
    company: 1002,
    licensedTo: 1003,
    personalFolderAdd: 1011,
    rename: 1016,
    del: 1017,
    fieldAttributes: 1023,
    titleAttributes: 1024,
    duplicate: 1025,
    printFormatErrText: 1026,
    deleteWarn: 1027,
    fontTypeText: 1029,
    fontSizeText: 1030,
    colorNegText: 1031,
    decimalPlacesText: 1032,
    dateFormatTxt: 1033,
    editTooltipText: 1060,
    newTemplatePlaceholderText: 1061,
    readonlyTooltipText: 1088,
    show: 1090,
    duplicateTemplateErr: 1096,
    ignoreCaseText: 1097,
    printLabelSettingsTitle: 1100,
    noWrapText: 1129,
    customRange: 1247,
    from: 1248,
    to: 1249,
    packHiddenRepText: 1315,
    packHiddenRepColText: 1316,
    packages: 1332,
    packagesTip: 1334,
    packagesTip2: 1335,
    packagesTipTitle: 1337,
    hide: 1338,
    move: 1339,
    pack: 1341,
    newTab: 1342,
    picdesign: 1343,
    thisForm: 1346,
    allPackage: 1347,
    showPackWarn: 1348,
    hidePackWarn: 1349,
    showPackTxt: 1350,
    hidePackTxt: 1351,
    showCategoryTxt: 1352,
    hideCategoryTxt: 1353,
    duplicateContainerErr: 1354,
    deleteValidationTxt: 1355,
    nameMandatoryTxt: 1356,
    saveChanges: 1357,
    defaults: 1358,
    save: 1359,
    dirAct: 1361,
    mergeTooltip: 1363,
    splitTooltip: 1364,
    newBoxTooltip: 1365,
    sameBoxTooltip: 1366,
    newBoxFieldTooltip: 1367,
    moveToTopTooltip: 1368,
    moveUpTooltip: 1369,
    moveDownTooltip: 1370,
    moveToBottomTooltip: 1371,
    yourPriorityTxt: 1372,
    nameDoubleWarn: 1373,
    nameDoubleOk: 1374,
    nameDoubleCancel: 1375,
    unsavedChangesWarn: 1377,
    hiddenPack: 1379,
    moduleHiddenTooltip: 1386,
    btnSaveAndAddContainerText: 1390,
    newTemplateBtnText: 1392,
    newContainerPlaceholderText: 1393,
    newContainerBtnText: 1394,
    showCategoryWarn: 1395,
    hideCategoryWarn: 1396,
    copyOfLabel: 1397,
    withoutPack: 1398,
    hiddenTabTooltip: 1399,
    readOnlyTooltip: 1400,
    editableFileTooltip: 1401,
    hiddenPrintFormat: 1402,
    hiddenPrintReport: 1403,
    insertHyperlink: 1404,
    textLabel: 1405,
    hyperlinkLabel: 1406,
    noLinkError: 1407,
    typeLabel: 1408,
    // header
    moreOptions: 1445,
    // saved searches
    savedSearches: 1410,
    createNewSearch: 1411,
    unsetDefault: 1412,
    newSearch: 1413,
    // popup
    backtoList: 1414,
    popupNewRecord: 1415,
    // filters
    newField: 1416,
    equals: 1417,
    notEquals: 1418,
    less: 1419,
    greater: 1420,
    lessOrEqual: 1421,
    greaterOrEqual: 1422,
    later: 1423,
    before: 1424,
    between: 1425,
    startsWith: 1426,
    endsWith: 1427,
    contains: 1428,
    filtersRangeOneField: 1429,
    filterMin: 1430,
    filtersMax: 1431,
    searchPrefix: 1432,
    searchBy: 1433,
    changeSearchBy: 1434,
    noSearchResults: 1435,
    searchSelectPlaceholder: 1436,
    typePlaceholder: 1437,
    ignorecase: 1438,
    searchFromBegining: 1439,
    caseSensitive: 1440,
    sortHint: 1441,
    addButton: 1442,
    selectFieldPlaceholder: 1443,
    searchTooltip: 1448,
    previousSearches: 1451,
    previousSearch: 1452,
    clearSearch: 1453,
    apply: 1454,
    saveAsNew: 1455,
    saveAndApply: 1456,
    clearFilter: 1457,
    nameSearch: 1458,
    saveAndNameSearch: 1459,
    filtersSort: 1460,
    addItem: 1461,
    searchActPlaceholder: 1462,
    searchTitleExists: 1463,
    applyAddToList: 1464,
    zoomButtonAlt: 1466,
    clearForm: 1470,
    selectedNum: 1570,
    selectAll: 1571,
    noCategorySearchResults: 1574,
    entity: 1578,
    /* it would be great if we enter the texts according to their id */
    copyTemplate: 1391,
    fromMenu: 156,
    toMenu: 157,
    /* header texts */

    results: 512,
    field: 1360,
    count: 1450,
    subtotal: 1449,
    activeScreens: 1203,
    lastUpdates: 1270,
    recentItems: 171,
    closeAll: 1114,
    newTxt: 1019,
    designSettingsRules: 1444,
    /* footer texts */
    back: 78,
    chooseValue: 1299,
    chooseAndBack: 1300,
    /* my menu */
    myMenuAdd: 1572,
    myMenuDelete: 1573,
    /* form labels */
    printLabelTooltip: 1580,
    labelAllRecords: 1584,
    labelClearPrev: 1585,
    saveSettings: 1586,
    print: 1587,
    printLabel: 1591,
    printLabelSelectTitle: 1592,
    allRecordsHelp: 1593,
    clearLastHelp: 1594,
    printImmediately: 1604,
    printImmediatelyHelp: 1605,
    prepareLabel: 1607,
    confirmLabel: 1608,
    quickPrintTooltip: 1609,
    printLabelDialogHelp: 1610,
    pasteWarn: 1611,
    PrintNA: 1619,

    yes: 1589,
    no: 1590,

    /* EDI Companies*/
    EDIDialogTitle: 1595,
    EDISearch: 1596,
    EDISelectAll: 1597,
    EDISelected: 1598,
    EDISendAll: 1599,
    EDISendAllHelp: 1600,
    EDIConfirm: 1601,
    EDINoResults: 1602,
    EDIGrillMessage: 1603,
    SendFinish: 1606,
    actionTooltip: 1620,

    /* Recon Remarks*/
    AddRemarksHover: 1622,
    AddRemarks: 1623,
    RemarksPlaceholder: 1624,
    AddRemarksSave: 1625,
    AddRemarksCancel: 1626,

    /* App searches*/
    AppSearchTitle: 1630,
    AddSearchBtnTooltip: 1631,
    AppSearchGeneralTitle: 1632,
    NameYourSearch: 1633,
    SearchNameDefault: 1634,
    AppSearchSetDefault: 1635,
    FixedSearch: 1636,
    FixedSearchDesc: 1637,
    Conditions: 1638,
    AppSearchCancel: 1639,
    NoFieldEmptyState: 1640,
    NotFormTypeTooltip: 1647,
    IsSubFormTooltip: 1648,
    AppSearchDlgTitle: 1650,
    Name: 1651,
    Number: 1652,

    /* Search Operators*/
    EmptyOperator: 1641,
    NotEmptyOperator: 1642,

    /*Quick Customer */
    createCustomerTitle: 1644,
    addCustomerDetails: 1645,
    exitNoSaveMessage: 1646,
    saveAndConvert: 1649,

    /* App Search */
    CurrentUserSearch: 1654,
    CurrentUserSearchHelp: 1655,

    /* predefined dates*/
    yesterday: 1662,
    today: 1663,
    tomorrow: 1664,
    currentWeekStart: 1665,
    currentWeekEnd: 1666,
    currentMonthStart: 1667,
    currentMonthEnd: 1668,
    currentQuarterStart: 1669,
    currentQuarterEnd: 1670,
    currentYearStart: 1671,
    currentYearEnd: 1672,
    lastWeekStart: 1673,
    lastWeekEnd: 1674,
    lastMonthStart: 1675,
    lastMonthEnd: 1676,
    lastQuarterStart: 1677,
    lastQuarterEnd: 1678,
    lastYearStart: 1679,
    lastYearEnd: 1680,
    nextWeekStart: 1681,
    nextWeekEnd: 1682,
    nextMonthStart: 1683,
    nextMonthEnd: 1684,
    nextQuarterStart: 1685,
    nextQuarterEnd: 1686,
    nextYearStart: 1687,
    nextYearEnd: 1688,
    finvoicesEolMsg: 1723,
    finvoicesEolTitle: 1724,
    finvoicesEolOkButton: 1725,
    finvoicesEolNotNowButton: 1726,
    changeSearchByCategoryLabel: 1728,
    searchByNumber: 1729,
    searchByName: 1730,
    searchByOtherCriteria: 1731,
    privilegeGroup: 1759,
    recommendationForYou: 1760,
    recommendationPreText: 1761,
    recommendationCreate: 1762
};

export const generatorMessages = {
    actionPanelTitleText: 9,
    addFieldMsgText: 14,
    englishTabText: 15,
    hebrewTabText: 16,
    conditionPanelTitleText: 20,
    whenPanelTitleText: 26,
    valueMsgText: 39,
    toggleActiveText: 40,
    searchMsgText: 71,
    toggleAndText: 77,
    toggleOrText: 78
};

export const packges = 1332;

export const textConst = {
    closeAlt: 'Close',
    plusAlt: 'Plus',
    hiddenSignAlt: 'Hidden',
    packageAlt: 'Package',
    infoAlt: 'Information',
    moreAlt: 'More',
    confirmAlt: 'Confirm',
    expanShrinkAlt: 'Expand or shrink',
    hiddenAlt: 'Hidden',
    showMoreAlt: 'Show more',
    cancelAlt: 'Cancel',
    approveAlt: 'Approve',
    newAreaAlt: 'New area',
    mergedFieldAlt: 'Merged field',
    pinnedFieldAlt: 'Pinned field',
    moveTopAlt: 'Move to top',
    moveUpAlt: 'Move up',
    moveDownAlt: 'Move down',
    moveToBottomAlt: 'Move to bottom',
    moduleHiddenAlt: 'Module hidden'
};

export const categoryDesc = {
    ייצור: {
        desc: `חבילות יצור כוללות ניהול של תהליכים הקשורים לייצור מוצרים מוגמרים מחומרי גלם או מרכיבים. הן כוללות הרכבות, ניהול של עץ המוצר של המוצר המיוצר, מידול של תהליך היצור של מוצר מסוים, רישום דווחי יצור של מוצרים, מעקב אחר תשומות שהושקעו ביצור, ועוד.
    חלק מהחבילות בקטגוריה זו זמינות רק למשתמשים עם רישוי מתאים.`
    },
    כספים: {
        desc: `בקטגוריה זו תוכל למצוא חבילות בנושאים הקשורים לניהול כספים של החברה וטיפול בהנהלת החשבונות. כאן אפשר למצוא, בין השאר, טיפול בתקציבים וברכוש קבוע, מעקב אחרי אשראי ואובליגו, טיפול בהצמדות ועבודה בסביבת מטבע בינלאומית, ועוד.`
    },
    לוגיסטיקה: {
        desc: `חבילות בקטגורית לוגיסטיקה מאפשרות ניהול הרכש והמלאי בעסק שלך, החל מניהול מלאי, טיפול במנות חומרים, המשך בטיפול בשילוח ואריזות, וכולל גם טיפול במחסני ערובה. בצד הרכש יש טיפול בנושאים כגון ניהול הצעות מחיר ומחירונים לספקים, רישום של דרישות רכש, טיפול בתיקי יבוא, ועוד.`
    },
    לוקליזציה: {
        desc: `קטגוריית הלוקליזציה כוללת חבילות שונות להתאמת המערכת לדרישות הרגולטוריות במגוון מדינות בעולם, כגון ארה"ב, האיחוד האירופי, אנגליה, ישראל, מקסיקו, וחלק ממדינות דרום אמריקה.`
    },
    'מנהל מערכת': {
        desc: `קטגוריה זו עוסקת בכלים שונים לניהול ותחזוקה של מערכת Priority. אלה כוללים ניהול משתמשים והרשאות, טיפול בחברות במערכת, כלים להסבת נתונים ממערכות קודמות, ועוד.`
    },
    'שיווק ומכירות': {
        desc: `החבילות בקטגוריה זו מאפשרות לנהל את קשרי הלקוחות שלך החל משלב הליד, כולל לקוחות זמניים. בין החבילות נמצאים גם כלים לניהול הזדמנויות מכירה ומיזמים שווקיים. בצד המכירות יש חבילות לניהול הצעות מחיר ללקוחות, טיפול בסוכני מכירות, ניהול של מחירונים, מבצעים ובונוסים, וחבילות נוספות.`
    },
    תפעול: {
        desc: `קטגוריה זו כוללת מגוון של חבילות שנועדו לייעל את תהליכי העבודה הפנימיים בארגון. ביניהן ניתן למנות ניהול פרויקטים, ניהול משאבי אנוש, מעקב אחר נוכחות עובדים, טיפול בשכר, הגדרת תהליכי עבודה בארגון (BPM), שרות לקוחות, אבטחת איכות, ועוד מגוון אפשרויות.
    חלק מהחבילות בקטגוריה זו זמינות רק למשתמשים עם רישוי מתאים.`
    },
    'System Maintenance': {
        desc: `This category deals with various tools for the management and maintenance of the Priority system. These include user management and permissions, the handling of companies in the system, tools for converting data from previous systems, and more.`
    },
    Finance: {
        desc: `In this category you'll find packages on issues related to managing your company's finances and accounting. Among the focus areas, you'll find, the handling of budgets and fixed assets, tracking credit and liability, dealing with linkages, working in an international environment with multiple currencies, and more.`
    },
    Localization: {
        desc: `Priority accommodates the accounting and taxation conventions in a wide range of countries. These localization packages add components for complying with various government regulations, including those in the US, UK, EU member countries, Israel, Mexico, and certain countries in South America. Select the package that suits your regional needs.`
    },
    Production: {
        desc: `Production packages include the management of processes related to the production of finished products from raw materials or components, including warehouse assembly, management of a bill of materials for the product, modeling of the production process, recording and generating production reports, tracking the investment of resources in production, and more. Some packages in this category are only available to users with appropriate licensing.`
    },
    Logistics: {
        desc: `These packages allow you to manage your workflow's purchasing and inventory, from inventory management, product handling, shipment and packaging handling, included the management of bonded warehouses. On the purchasing side, use these packages to handle  issues such as managing quotations and price lists for vendors, recording purchase requisitions, handling shipping vouchers, and more.`
    },
    'Marketing and Sales': {
        desc: `Priority's marketing and sales packages provide the functionality to manage customer relationships from initial contact through the final sale. CRM capabilities facilitate the management of leads, contacts, sales opportunities, and marketing campaigns. These packages include tools that manage pricing, bonuses, ordering, billing, forecasting, reporting, and more. Select the packages that respond to the needs of your pipeline.`
    },
    Operations: {
        desc: `This category includes a variety of packages designed to streamline the organization's internal work processes. These include project management, human resource management, employee attendance, payroll, business process management (BPM), customer service, quality assurance, and a various other options. Some packages in this category are only available to users with appropriate licensing.`
    },
    info: {
        descHebrew: `חבילות מאפשרות לך למקד את עיצוב המערכת לפי חבילות שכוללות את הכלים והפונקציונאליות שאתה צריך. כל חבילה עוסקת בעולם תוכן מסוים (למשל, עבודה עם סוכני מכירות), והצגה או הסתרה של החבילה תציג או תסתיר את כל המרכיבים הכלולים בחבילה ברחבי המערכת. כך, אם אתה לא עובד עם סוכנים, תוכל להסתיר את החבילה, וכל המרכיבים הקשורים לסוכנים (כולל מסכים, דו"חות, ועוד) יוסתרו עבורך. עיצוב לפי חבילות הוא לפי המשתמש ורק בחברה הנוכחית.`,
        descEnglish: `The design-by-package feature allows you to streamline the system design by displaying or hiding packages that include the tools and functionality you need. Each package deals with certain subject matter (for example, working with sales representatives), and displaying or hiding the package will display or hide all components included in the package throughout the system. So if you don't work with sales representatives, you can hide that package, and all components connected to them (including forms, reports, etc.) will be hidden for you. Design by package applies only to the user and only for the current company`
    }
};
